import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import UserActionService from '../../services/UserActionService';
import StringUtils from '../../utils/StringUtils';
import ActionButton from '../../components/ActionButton';
import store from '../../store';
import Constants from '../../utils/constants';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import InputNumberComponent from '../../components/inputs/InputNumberComponent';
import InputCalendarRangeComponent from '../../components/inputs/InputCalendarRangeComponent';
import moment from 'moment';
import DivContainer from '../../components/DivContainer';

class UserActionListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new UserActionService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            renderDialog: false,
            eventDetails: undefined,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            showConfirmRemoveDialog: false,
            selectedList: [],
            unselectedList: [],
            locale: props.locale
        };
    }

    updateSearchCriteria(criteria) {
        return {
            actionId: criteria.actionId,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
            email: criteria.email,
            name: criteria.name,
        };
    }

    getCleanSearchCriteria() {
        return {
            actionId: this.props.elementId,
            email: '',
            name: '',
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: false,
        };
    }

    initializeFromBackend() {}

    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return 'user-action.listTitle';
    }
    getCriteriaName() {
        return 'user-action-list-sc';
    }

    getContainerListName() {
        return 'user-action-list-container';
    }
    renderPreFilter() {
        const {locale} = this.state;
        return (
              <DivContainer colClass='p-card p-component details-card mt-2'>
            <div className='row'>              
              <InputTextComponent
                                     id={`${locale}-title`}
                                     name='title'
                                     label={t('action.action')}
                                     colClass='col-md-2'
                                     value={this.getExtra()?.translations[locale]?.title}
                                     validator={this.validator}
                                     validators='required|max:128'
                                     onChange={this.handleChange}
                                     viewMode={'VIEW'}
                                     stateField={`element.translations[${locale}]`}
                                     validateViewMode
                                     idForViewValidation
                                 />                                
                                 <InputCalendarRangeComponent
                                     id=""
                                     key={'active'}
                                     idFrom={'activeFrom'}
                                     idTo={'activeTo'}
                                     nameTo={'activeTo'}
                                     nameFrom={'activeFrom'}
                                     label='' 
                                     labelFrom={t('action.activityRangeFrom')}
                                     labelTo={t('action.activityRangeTo')}
                                     colClass='col-2'
                                     from={this.getExtra()?.activeFrom}
                                     to={this.getExtra()?.activeTo}
                                     validator={[this.validator, this.validatorDraft]}
                                     onChange={this.handleChange}
                                     viewMode={'VIEW'}
                                     showTime
                                     showIcon                                     
                                     placeholderFrom='dd-mm-rrrr GG:MM'
                                     placeholderTo='dd-mm-rrrr GG:MM'
                                     validateViewMode
                                     dateFormatMoment='DD-MM-YYYY HH:mm'
                                     validatorsToType='after_or_equal_datetime'
                                 />   


            
            </div>
            </DivContainer>
        );
    }
    

    renderCriteria() {
        return (        
            <div>
                <div className='row'>
                    <CriteriaTextComponent
                        id='email-sc'
                        name='email'
                        label={t('user.email')}
                        colClass='col-lg-3 col-sm-6'
                        value={this.state.criteria.email}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />
                    <CriteriaTextComponent
                        id='name-sc'
                        name='name'
                        label={t('user.name')}
                        colClass='col-lg-3 col-sm-6'
                        value={this.state.criteria.name}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />
                </div>
            </div>
        );
    }

    tableHeader() {
        const isSurveyDisabled = (this.getExtra()?.status.value === 'DRAFT') || moment(this.getExtra()?.activeTo).isAfter(moment());

        return (
            <div className=" d-flex ">
            <ActionButton
                label={t('user-action.createSurvey')}
                disabled={!(this.state.selectAllMode || (!this.state.selectAllMode && this.state.selectedList.length > 0)) || isSurveyDisabled}
                handleClick={(e) => {
                    if (this.state.selectAllMode) {
                        this.blockUi();
                        const criteria = this.state.criteria;
                        criteria.maxResults = Constants.INTEGER_MAX_VALUE;
                        this.service
                            .getList(criteria)
                            .then((data) => {
                                this.unblockUi();
                                const elements = data.content;
                                const unselectedListIds = this.state.unselectedList.map((el) => el.id);
                                const filteredElements = elements.filter((element) => !unselectedListIds.includes(element.id));
                                this.storeListAndRedirect(filteredElements);
                            })
                            .catch((err) => {
                                this.unblockUi();
                                console.error(err);
                                this.showErrorMessage('Nie można pobrać listy');
                            });
                    } else this.storeListAndRedirect();
                }}
            />
        
            <span className="text-warning font-16-600 align-self-center">
                {isSurveyDisabled ? t('user-action.survey-disabled') : ''}
            </span>
        </div>
        );
    }
    storeListAndRedirect(listOfElements = this.state.selectedList, e) {
        store.getState().setQuizForUserActionEnabled(true);
        store.getState().setUserActionsToQuiz(listOfElements);
        const {newQuizUrl} = this.props;
        const href = `${newQuizUrl}/` + sessionStorage.getItem('i18nextLng');
        this.handleGoToDetail(href, e);
    }
    prepareHeaderItems() {
        return [];
    }

    prepareColumns() {
        return [
            {
                field: 'email',
                header: t('mobileUser.email'),
                sortable: true,
                sortField: 'user.email',
            },
            {
                field: 'name',
                header: t('login.form.userName'),
                sortable: true,
                sortField: 'user.name',
            },
            {field: '', header: t('user-action.photo'), body: this.photoTemplate},
            {
                field: 'firstName',
                header: t('user.firstName'),
                sortable: true,
                sortField: 'user.firstName',
            },
            {
                field: 'lastName',
                header: t('user.lastName'),
                sortable: true,
                sortField: 'user.lastName',
            },
        ];
    }

    photoTemplate = (rowData) => {
        const fileUuid = rowData?.fileUuid;
        const photoPath = this.service.getPath() + `/${fileUuid}/after-photo`;
        const img = StringUtils.isBlank(fileUuid) ? (
            ''
        ) : (
            <img
                src={`${photoPath}?token=${this.authService.getToken()}`}
                alt='Zdjęcie'
                onClick={()=>this.showImage(`${photoPath}?token=${this.authService.getToken()}`, t('user-action.photo'))}
                className='product-image cursor-pointer'
                style={{borderRadius: '50%', height: '30px', width: '30px', marginBottom: '-10px', marginTop: '-10px'}}
            />
        );
        return img;
    };
    handleGoBack(e) {
        e.preventDefault();
        this.blockUi();
        const {backUrl} = this.props;
        this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderDialog() {
        return null;
    }

    breadCrumbItems() {
        return [
            {name: t('action.listTitle'), url: '/action-list'},
            {name: t('user-action.listTitle'), url: ''},
        ];
    }
    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
}

UserActionListContainer.defaultProps = {
    detailUrl: '/action/details',
    newUrl: '/action/create',
    editUrl: '/action/edit',
    newQuizUrl: '/quiz/create',
    renderChangeLanguegeFilter: true,
    lazy: true,
    selectionMode: 'multiple',
};

UserActionListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newQuizUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(withTranslation()(UserActionListContainer));
